import React from 'react';
import { UserIcon, BuildingIcon, BriefcaseIcon, CodeIcon } from 'lucide-react';
const ClientTypeCard = ({
  icon: Icon,
  title,
  description
}) => {
  return <div className="border border-zinc-200 p-8 rounded-sm gradient-card-medium" data-id="element-30">
      <div className="text-teal-dark mb-6" data-id="element-31">
        <Icon size={32} data-id="element-32" />
      </div>
      <h3 className="font-serif text-2xl mb-4 text-zinc-900" data-id="element-33">{title}</h3>
      <p className="text-zinc-600" data-id="element-34">{description}</p>
    </div>;
};
export const ClientProfile = () => {
  return <section id="client-profile" className="py-24 bg-white text-zinc-800" data-id="element-35">
      <div className="container-custom" data-id="element-36">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-37">
          <h2 className="font-serif text-4xl mb-6 text-zinc-900" data-id="element-38">
            Who You <span className="accent-text" data-id="element-39">Are</span>
          </h2>
          <p className="text-zinc-600" data-id="element-40">
            Our ideal clients are forward-thinking leaders who recognize the
            transformative potential of AI and want to leverage it for business
            growth.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-41">
          <ClientTypeCard icon={BuildingIcon} title="CEO or Business Owner" description="You're looking for AI to automate a part of your business, enhance customer experience, or create new revenue streams through innovative AI solutions." data-id="element-42" />
          <ClientTypeCard icon={CodeIcon} title="Tech or AI Startup Founder" description="You're seeking full-cycle expertise to bring your AI product vision to life, from concept to market-ready solution with technical infrastructure that can scale." data-id="element-43" />
          <ClientTypeCard icon={BriefcaseIcon} title="Agency Owner" description="You operate in an adjacent business looking to adopt AI capabilities to enhance your service offerings and provide cutting-edge solutions to your clients." data-id="element-44" />
          <ClientTypeCard icon={UserIcon} title="Development In Progress" description="You've already started developing an AI product but now need professional specialists to tackle particular challenges or accelerate your time to market." data-id="element-45" />
        </div>
      </div>
    </section>;
};